import i18n from 'i18next';
export const handleBackendValidationErrors = (
  fieldMapping: Record<string, string>,
  error: any,
  setError: (name: string, error: { type: string; message: string }) => void,
) => {
  if (error?.status === 400 && error?.data.errors) {
    const backendError = error.data.errors;

    Object.keys(backendError).forEach((backendField) => {
      const formField = fieldMapping[backendField] || backendField.toLowerCase();
      const errorMessages = backendError[backendField];

      if (errorMessages && errorMessages.length > 0) {
        setError(formField as any, {
          type: 'server',
          message: i18n.t(`server.${errorMessages[0]}`, { ns: 'validation' }),
        });
      }
    });

    return true; // Indicates errors were handled
  }
  return false; // Indicates errors were not handled
};
